import { useEffect, useState } from 'react';

export type WindowDimensions = {
  windowHeight: number | null;
  windowWidth: number | null;
};

function getWindowDimensions(offset?: number): WindowDimensions {
  if (typeof window === 'undefined') {
    return {
      windowHeight: null,
      windowWidth: null,
    };
  }

  const { innerWidth: windowWidth, innerHeight: windowHeight } = window;
  return {
    windowHeight,
    windowWidth: windowWidth - (offset ?? 0),
  };
}

export default function useWindowDimensions(offset?: number) {
  const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>(
    getWindowDimensions(offset)
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions(offset));
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [offset]);

  return windowDimensions;
}
